import React, {useState} from 'react';
import DemandCreate from "../../components/crud/DemandCreate";
import Main from "../../components/main/Main";
import DemandList from "../../components/list/DemandList";
import { useTranslation } from 'react-i18next';                   /* Added Line */

function Mutalaa(props) {
    const [refreshList, setRefreshList] = useState(false);
    const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
    const [selectedRow, setSelectedRow] = useState(false);
    const [t, i18n] = useTranslation();         /* Added Line */

    const onUpdateButtonClicked = (selectedRow) => {
        setUpdateButtonClicked(true);
        setSelectedRow(selectedRow)
    }

    return (
        <Main>
            <DemandCreate type={2} talepTurId={13} updateButtonClicked={updateButtonClicked} setUpdateButtonClicked={setUpdateButtonClicked} selectedRow={selectedRow} refreshList={refreshList} setRefreshList={setRefreshList} pageTitle={t("sidebar.sirketlerHukukunaIliskinGorusTalepleri")}/>
            <DemandList refreshList={refreshList} onUpdateButtonClicked={onUpdateButtonClicked} setRefreshList={setRefreshList} talepTurId={13} />
        </Main>
    );
}

export default Mutalaa;